// extracted by mini-css-extract-plugin
module.exports = {"layout":"content-card_layout__Pnm0b","meta":"content-card_meta__4kWfg","hero":"content-card_hero__Je6qP","titleLink":"content-card_titleLink__Ytoxr"};